
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { D as extractListeners } from './index-2216d089.js';
import './chakra-ui-styled-system.esm-a8a2e91f.js';
import './internal-icons-3bdf43cd.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-de5da461.js';
import CBox from './CBox.js';
import { C as CIcon } from './index-ff45b78b.js';
import './CVisuallyHidden.js';
import './CSpinner.js';
import { b as buttonProps, C as CButton } from './index-5e583f94.js';

/**
 * Hey! Welcome to @chakra-ui/vue IconButton
 *
 * CIconButton is used to render icons that support
 * click interactions.
 *
 * CIconButton composes the CButton component, except that it renders only an icon.
 *
 * @see Docs     https://vue.chakra-ui.com/iconbutton
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CIconButton/CIconButton.js
 */
function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}
var baseStyles = {
  display: 'inline-flex',
  appearance: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 250ms',
  userSelect: 'none',
  position: 'relative',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
  lineHeight: '1.2',
  outline: 'none'
};
/**
 * CIconButton component
 *
 * CIconButton is used to render icons that support
 * click interactions
 *
 * @extends CButton
 * @see Docs https://vue.chakra-ui.com/iconbutton
 */

var CIconButton = {
  name: 'CIconButton',
  functional: true,
  props: Object.assign({}, {
    icon: {
      type: [String]
    },
    isRound: {
      type: [Boolean]
    },
    ariaLabel: {
      type: [String],
      required: true
    }
  }, buttonProps),
  render: function render(h, context) {
    var ref = context.props;
    var isFullWidth = ref.isFullWidth;
    var leftIcon = ref.leftIcon;
    var rightIcon = ref.rightIcon;
    var loadingText = ref.loadingText;
    var rest = objectWithoutProperties(ref, ["isFullWidth", "leftIcon", "rightIcon", "loadingText"]);
    var props = rest;
    var ariaLabel = props.ariaLabel;
    var isRound = props.isRound;
    var icon = props.icon;
    var nonNativeEvents = {
      click: function click(e) {
        var emitClick = context.listeners.click;

        if (emitClick) {
          emitClick(e);
        }
      }
    };
    var ref$1 = extractListeners(context, nonNativeEvents);
    var native = ref$1.native;
    var nonNative = ref$1.nonNative;
    return h(CButton, {
      props: props,
      attrs: Object.assign({}, {
        'aria-label': ariaLabel,
        rounded: isRound ? 'full' : 'md'
      }, context.data.attrs, {
        'data-chakra-component': 'CIconButton',
        p: 0
      }),
      on: nonNative,
      nativeOn: native
    }, [typeof icon === 'string' ? h(CIcon, {
      props: {
        name: icon
      },
      attrs: Object.assign({}, baseStyles, {
        color: 'currentColor',
        mb: '2px',
        size: '1em',
        focusable: false,
        'aria-hidden': true
      })
    }) : h(CBox, {
      props: {
        as: icon
      },
      attrs: {
        focusable: true,
        color: 'currentColor'
      }
    })]);
  }
};

export default CIconButton;
